module.exports = __webpack_public_path__ + "img/10diamante.39ef422e.png";